import React, { useEffect, useState } from 'react';

import { Character, CharacterSheetInterface } from "@dndModels";
import { CreatureType } from '@dndModels/Types';
import { CREATURE_TYPES } from '@dndModels/Constants';

import FlexBox from '@components/layout/FlexBox';
import SelectStringBox from '@components/input/selects/SelectStringBox';

interface Props {
  char: CharacterSheetInterface;
}

export default function CharacterCreatureTypeCustomization({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  return (
    <FlexBox direction="row" className="padded" style={{ width: "100%" }}>
      <FlexBox xs_expand={0} style={{ width: "33%" }} className="centered" direction="column">
        <FlexBox xs_expand={0} className="header">
          Creature Type: 
        </FlexBox>
        <FlexBox xs_expand={0} className="small_label gray">
          Currently { char.creature_type }
        </FlexBox>
      </FlexBox>
      <FlexBox>
        <SelectStringBox
          name=""
          value={char.customizations.creature_type ? char.customizations.creature_type : "Don't Override"}
          options={CREATURE_TYPES}
          label_above
          extra_options={["Don't Override"]}
          onChange={(changed: CreatureType | "Don't Override") => {
            if (changed === "Don't Override") {
              delete char.customizations.creature_type;
            } else {
              char.customizations.creature_type = changed;
            }
            setPing(!ping);
            char.changed();
            char.subscription_holder.modalClosed();
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}

